import { memo, useMemo } from 'react'
import { DateTime } from 'luxon'

import { Table, Text } from '@domain-group/suit-theme'

import { capitalizeString, digObject, formatDate } from '@domain-group/javascript-utils'

import type { PublicationEditionModel, PublicationModel } from '@models/types'
import { formatRelativeDate } from '@functions/formatRelativeDate'

const buildColumns = () => [
  {
    title: 'Publication',
    dataKey: 'publication.title',
    render: (publication: PublicationModel) => publication?.title,
  },
  {
    title: 'Next Deadline',
    dataKey: 'id',
    render: (id: number, publicationEdition: PublicationEditionModel) => {
      const { date, type } = digObject(publicationEdition, 'deadlines.next_up', {})
      const typeText = type === 'ofi' ? 'OFI' : capitalizeString(type)
      return `${typeText} ${formatRelativeDate(date)}`
    },
  },
  {
    title: 'Deadline Date',
    dataKey: 'publication_id',
    render: (publication_id: number, publicationEdition: PublicationEditionModel) => {
      const { date } = digObject(publicationEdition, 'deadlines.next_up', {})
      return formatDate(date, 'dd/MM/yyyy HH:mm', 'dd/MM/yyyy \'at\' HH:mm')
    },
  },
  {
    title: 'Publication Date',
    dataKey: 'publication_date',
    render: (publicationDate: string) => {
      const publicationDateTime = DateTime.fromFormat(publicationDate, 'dd/MM/yyyy')
      return publicationDateTime?.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
    },
  },
  {
    title: 'Items',
    dataKey: 'order_item_count',
    render: (orderItemCount: number) => (
      <Text minWidth="fit-content" variant="ellipsis">
        {orderItemCount === 1 ? '1 Order' : `${orderItemCount} Orders`}
      </Text>
    ),
  },
]

interface PublicationEditionsTableProps {
  publicationEditions: PublicationEditionModel[],
}

const PublicationEditionsTable = (props: PublicationEditionsTableProps) => {
  const { publicationEditions } = props

  const memoColumns = useMemo(() => buildColumns(), [publicationEditions.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      // @ts-expect-error TS2322
      data={publicationEditions}
      stickyHeader
    />
  )
}

export default memo(PublicationEditionsTable)
